const state = {

  /** Array user */
    user : null ,
    sessionId : '' ,
    lang : 'fr' ,

}
const mutations = {

  /** Definir le session ID */
  SET_SESSIONID(state, payload) {
    //console.log('SET_USER', payload);
    state.sessionId = payload ;
  },
  /** Definir l'user */
  SET_USER(state, payload) {
    //console.log('SET_USER', payload);
    state.user = payload ;
  },
   /** Suppression array user */
   REMOVE_USER(state) {
    state.user = [];
},

}
export default {
    state,
    mutations,
}